enum TaskIssueType {
    DESIGNER_SWITCH_REQUEST = 'designer_switch_request',
}

export default TaskIssueType;
